(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prehotsale-01-topbar"] && !Shopify.designMode) return;
  try {
    
(function(){'use strict';
if (window.__phInit) return; window.__phInit = true;
function safe(fn,l){try{fn()}catch(e){console.warn('[NIESS pre-hotsale] '+l+':',e)}}

function bootCountdown(){
  var root = document.querySelector('[data-ph-countdown]');
  if (!root) return;
  var startIso = root.dataset.startIso;
  var endIso = root.dataset.endIso;
  var statusEl = root.querySelector('[data-ph-cd-status]');
  var nums = {
    d: root.querySelector('[data-cd="d"]'),
    h: root.querySelector('[data-cd="h"]'),
    m: root.querySelector('[data-cd="m"]'),
    s: root.querySelector('[data-cd="s"]')
  };
  if (!nums.d) return;
  var startMs = Date.parse(startIso), endMs = Date.parse(endIso);
  if (isNaN(startMs) || isNaN(endMs)) return;
  var labelBefore = root.dataset.labelBefore || 'Inicia en';
  var labelDuring = root.dataset.labelDuring || 'Termina en';
  var labelEnded = root.dataset.labelEnded || 'Pre Hot Sale finalizado';
  function pad(n){return n<10?'0'+n:''+n}
  function tick(){
    var now = Date.now(), target, label, live;
    if (now < startMs) { target = startMs; label = labelBefore; live = false; }
    else if (now < endMs) { target = endMs; label = labelDuring; live = true; }
    else {
      nums.d.textContent='00'; nums.h.textContent='00'; nums.m.textContent='00'; nums.s.textContent='00';
      if (statusEl) { statusEl.textContent = labelEnded; statusEl.classList.remove('is-live'); }
      return false;
    }
    var diff = Math.max(0, target - now);
    nums.d.textContent = pad(Math.floor(diff/86400000));
    nums.h.textContent = pad(Math.floor((diff%86400000)/3600000));
    nums.m.textContent = pad(Math.floor((diff%3600000)/60000));
    nums.s.textContent = pad(Math.floor((diff%60000)/1000));
    if (statusEl) { statusEl.textContent = label; statusEl.classList.toggle('is-live', live); }
    return true;
  }
  tick();
  var iv = setInterval(function(){ if (tick() === false) clearInterval(iv); }, 1000);
}

function bootKlaviyo(){
  window.addEventListener('klaviyoForms', function(e){
    if (e.detail && (e.detail.type === 'submit' || e.detail.type === 'success')) {
      var panel = document.querySelector('[data-ph-reveal-panel]');
      var card = document.querySelector('[data-ph-form-card]');
      if (panel) panel.classList.add('is-visible');
      if (card) {
        var top = card.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }
  });
}

function bootCopy(){
  var btn = document.querySelector('[data-ph-copy-btn]');
  var code = document.querySelector('[data-ph-code]');
  if (!btn || !code) return;
  btn.addEventListener('click', function(){
    var txt = code.textContent.trim();
    var orig = btn.textContent;
    var done = function(){
      btn.textContent = 'Copiado!';
      btn.classList.add('is-copied');
      setTimeout(function(){ btn.textContent = orig; btn.classList.remove('is-copied'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(done).catch(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = txt; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch(_){}
      document.body.removeChild(ta);
      done();
    }
  });
}

function bootFaq(){
  var items = document.querySelectorAll('.ph-faq-item');
  items.forEach(function(item){
    var q = item.querySelector('.ph-faq-q'), a = item.querySelector('.ph-faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function(){
      var open = item.classList.contains('is-open');
      items.forEach(function(other){
        other.classList.remove('is-open');
        var oa = other.querySelector('.ph-faq-a');
        if (oa) oa.style.maxHeight = null;
      });
      if (!open) { item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });
}

function bootReveal(){
  var els = document.querySelectorAll('[data-ph-reveal]');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('is-in'); }); return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function(el){ io.observe(el); });
  setTimeout(function(){ els.forEach(function(el){ el.classList.add('is-in'); }); }, 4000);
}

function boot(){
  safe(bootCountdown, 'countdown');
  safe(bootKlaviyo, 'klaviyo');
  safe(bootCopy, 'copy');
  safe(bootFaq, 'faq');
  safe(bootReveal, 'reveal');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
})();

  } catch(e) { console.error(e); }
})();
})();
